import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "hidden xl:grid max-w-screen-2xl m-auto grid-cols-3 gap-3" }
const _hoisted_6 = { class: "col-span-2 flex justify-between items-center" }
const _hoisted_7 = { class: "bg-white p-4 flex-col" }
const _hoisted_8 = { class: "text-3xl" }
const _hoisted_9 = { class: "max-w-screen-2xl m-auto grid grid-cols-1 xl:grid-cols-3 gap-3" }
const _hoisted_10 = {
  key: 0,
  class: "flex overflow-x-auto xl:grid xl:grid-cols-1 gap-3 py-4"
}
const _hoisted_11 = { class: "flex justify-between items-center py-4" }
const _hoisted_12 = { class: "flex overflow-x-auto xl:grid xl:grid-cols-1 gap-3 py-4" }
const _hoisted_13 = { class: "col-span-2" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "flex xl:hidden justify-between items-center" }
const _hoisted_16 = { class: "bg-white p-4 flex-col" }
const _hoisted_17 = { class: "text-3xl" }
const _hoisted_18 = { class: "py-4" }
const _hoisted_19 = { class: "p-4 bg-white" }
const _hoisted_20 = { class: "flex justify-end pt-3 gap-3 items-stretch" }
const _hoisted_21 = { class: "flex flex-col lg:col-span-3" }
const _hoisted_22 = { class: "flex flex-col p-4 bg-white my-3" }
const _hoisted_23 = ["innerHTML"]
const _hoisted_24 = { class: "flex items-center py-2" }
const _hoisted_25 = { class: "pt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_ModalAlert = _resolveComponent("ModalAlert")!
  const _component_CambiaStatoAlertModal = _resolveComponent("CambiaStatoAlertModal")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_AlertAutomatico = _resolveComponent("AlertAutomatico")!
  const _component_AlertManuale = _resolveComponent("AlertManuale")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_NextEditor = _resolveComponent("NextEditor")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_InfiniteLoading = _resolveComponent("InfiniteLoading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"]),
      _createVNode(_component_ModalAlert, {
        class: "z-50",
        azienda_id: _ctx.id,
        visible: _ctx.addAlertModalVisibility,
        "onUpdate:visible": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.addAlertModalVisibility) = $event)),
          _ctx.reloadAttivita
        ],
        id: _ctx.changeAlertId,
        "result-status": _ctx.resultStatus,
        "onUpdate:resultStatus": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.resultStatus) = $event))
      }, null, 8, ["azienda_id", "visible", "id", "result-status", "onUpdate:visible"]),
      _createVNode(_component_CambiaStatoAlertModal, {
        class: "z-50",
        visible: _ctx.changeStateAlertModalVisibility,
        "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.changeStateAlertModalVisibility) = $event)),
        onReject: _cache[3] || (_cache[3] = ($event: any) => (_ctx.changeStateAlertModalVisibility = false)),
        onConfirm: _ctx.changeStateAlertAutomatico,
        riepilogo: _ctx.riepilogo_stato_modal,
        abilitato: _ctx.alert_automatico?.abilitato,
        onClose: _cache[4] || (_cache[4] = ($event: any) => {_ctx.changeStateAlertModalVisibility = false; _ctx.riepilogo_stato_modal=false})
      }, null, 8, ["visible", "onConfirm", "riepilogo", "abilitato"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.paths }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              component: "router-link",
              to: {name: 'NuovoCliente'},
              class: "w-48 ml-3 text-sm py-2 px-4 m-0 hidden sm:block"
            }, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode(" + Aggiungi Cliente ")
              ])),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "flex self-center text-3xl font-bold" }, "Gestione Alert", -1)),
          _createElementVNode("div", _hoisted_6, [
            _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-3xl font-bold" }, "Attività", -1)),
            _withDirectives(_createElementVNode("div", _hoisted_7, [
              _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-sm flex justify-self-start" }, "Anniversario", -1)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$filters.toDate(_ctx.azienda?.data_anniversario)), 1)
            ], 512), [
              [_vShow, _ctx.azienda?.data_anniversario]
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", null, [
            _cache[17] || (_cache[17] = _createElementVNode("div", { class: "flex xl:hidden self-center text-3xl font-bold py-4" }, "Gestione Alert", -1)),
            _cache[18] || (_cache[18] = _createElementVNode("div", { class: "flex xl:hidden justify-self-start text-2xl py-4" }, "Alert automatici", -1)),
            (_ctx.alert_automatico)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_AlertAutomatico, {
                    inizio: _ctx.$filters.toDate(_ctx.alert_automatico?.inizio_attivita),
                    scadenza: _ctx.$filters.toDate(_ctx.alert_automatico?.scadenza),
                    id: _ctx.alert_automatico?.id,
                    onChangeState: _ctx.changeStateAlert,
                    abilitato: _ctx.alert_automatico?.abilitato
                  }, null, 8, ["inizio", "scadenza", "id", "onChangeState", "abilitato"])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_11, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-2xl" }, "Alert manuali", -1)),
              _createVNode(_component_NextButton, {
                variant: "primary",
                onClick: _ctx.modalAddAlert,
                class: "py-2 px-4 m-0"
              }, {
                default: _withCtx(() => _cache[15] || (_cache[15] = [
                  _createTextVNode(" + Aggiungi ")
                ])),
                _: 1
              }, 8, ["onClick"])
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts_manuali, (a) => {
                return (_openBlock(), _createBlock(_component_AlertManuale, {
                  key: a.id,
                  scadenza: _ctx.$filters.toDate(a.scadenza),
                  descrizione: a.descrizione,
                  id: a.id,
                  abilitato: a.abilitato,
                  updated_at: _ctx.$filters.toDate(a.updated_at),
                  onUpdate: _ctx.updateAlertManuale,
                  onStateChange: _ctx.fetchAlert,
                  onDelete: _ctx.handleDelete
                }, null, 8, ["scadenza", "descrizione", "id", "abilitato", "updated_at", "onUpdate", "onStateChange", "onDelete"]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_13, [
            (_ctx.permission_denied)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createVNode(_component_Alert, { class: "sticky top-0 z-10 bg-next-orange" }, {
                    default: _withCtx(() => _cache[19] || (_cache[19] = [
                      _createTextVNode("Non hai i permessi sufficienti per poter creare un'attività ")
                    ])),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_15, [
              _cache[21] || (_cache[21] = _createElementVNode("div", { class: "text-3xl font-bold" }, "Attività", -1)),
              _withDirectives(_createElementVNode("div", _hoisted_16, [
                _cache[20] || (_cache[20] = _createElementVNode("div", { class: "text-sm flex justify-self-start" }, "Anniversario", -1)),
                _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$filters.toDate(_ctx.azienda?.data_anniversario)), 1)
              ], 512), [
                [_vShow, _ctx.azienda?.data_anniversario]
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("div", _hoisted_19, [
                _createVNode(_component_NextEditor, {
                  modelValue: _ctx.testo_attivita,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.testo_attivita) = $event)),
                  class: "flex flex-grow mr-3 min-h-[176px]"
                }, null, 8, ["modelValue"]),
                _createElementVNode("div", _hoisted_20, [
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.tagsAutocomplete.selection,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.tagsAutocomplete.selection) = $event)),
                    options: _ctx.tagsAutocomplete.options,
                    multiple: true,
                    onSearchChange: _ctx.tagsAutocomplete.search,
                    "close-on-select": false,
                    "clear-on-select": false,
                    placeholder: "Contatti",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona",
                    class: "next-vue-multiselect",
                    "track-by": "id",
                    label: "full_name"
                  }, {
                    noResult: _withCtx(() => _cache[22] || (_cache[22] = [
                      _createTextVNode("Nessun elemento trovato.")
                    ])),
                    tag: _withCtx(({option, remove}) => [
                      _createVNode(_component_MultiselectOption, {
                        onRemove: ($event: any) => (remove(option))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(option.full_name), 1)
                        ]),
                        _: 2
                      }, 1032, ["onRemove"])
                    ]),
                    _: 1
                  }, 8, ["modelValue", "options", "onSearchChange"]),
                  _createVNode(_component_VueMultiselect, {
                    modelValue: _ctx.attivitaAutocomplete.selection,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.attivitaAutocomplete.selection) = $event)),
                    options: _ctx.attivitaAutocomplete.options,
                    onSearchChange: _ctx.attivitaAutocomplete.search,
                    placeholder: "Attività",
                    deselectLabel: "Deseleziona",
                    selectedLabel: "Selezionato",
                    selectLabel: "Seleziona",
                    class: "next-vue-multiselect-single",
                    "track-by": "id",
                    label: "descrizione"
                  }, null, 8, ["modelValue", "options", "onSearchChange"]),
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_Field, {
                      labelVisible: false,
                      required: true,
                      errors: [],
                      modelValue: _ctx.data_attivita,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.data_attivita) = $event)),
                      type: "date"
                    }, null, 8, ["modelValue"])
                  ]),
                  _createVNode(_component_NextButton, {
                    variant: "primary",
                    disabled: !this.testo_attivita || !this.data_attivita || _ctx.loading_creazione,
                    onClick: _ctx.creaAttvita,
                    class: "py-1 px-4 flex items-center justify-center"
                  }, {
                    default: _withCtx(() => [
                      _withDirectives(_createVNode(_component_Spinner, { class: "w-3 mr-3 right-1" }, null, 512), [
                        [_vShow, _ctx.loading_creazione]
                      ]),
                      _cache[23] || (_cache[23] = _createTextVNode(" Salva "))
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attivita, (a) => {
                return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                  _createElementVNode("div", {
                    innerHTML: a.descrizione,
                    class: "unreset border-b"
                  }, null, 8, _hoisted_23),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_24, [
                      _cache[24] || (_cache[24] = _createElementVNode("span", null, "Contatti: ", -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(a.tagged_contatti, (t) => {
                        return (_openBlock(), _createElementBlock("span", {
                          key: t.id,
                          class: "border p-1 mr-1"
                        }, _toDisplayString(t.full_name), 1))
                      }), 128)),
                      _cache[25] || (_cache[25] = _createElementVNode("span", null, "Attività: ", -1)),
                      _withDirectives(_createElementVNode("span", { class: "border p-1 mr-1" }, _toDisplayString(a.attivita_crm_label), 513), [
                        [_vShow, a.attivita_crm_label]
                      ])
                    ]),
                    _createElementVNode("small", _hoisted_25, " Pubblicata il " + _toDisplayString(_ctx.$filters.toDateTime(a.created_at)) + " da " + _toDisplayString(a.owner) + " | Data attività " + _toDisplayString(_ctx.$filters.toDate(a.data_attivita) ? _ctx.$filters.toDate(a.data_attivita) : '---'), 1)
                  ])
                ]))
              }), 256)),
              _createVNode(_component_InfiniteLoading, {
                onInfinite: _ctx.fetchNextPage,
                identifier: _ctx.infiniteIdentifier,
                style: {"min-height":"1px"}
              }, {
                complete: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createElementVNode("div", { class: "text-center pb-3" }, "Non ci sono altre attività.", -1)
                ])),
                _: 1
              }, 8, ["onInfinite", "identifier"])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}